// extracted by mini-css-extract-plugin
export var addToCartButton = "_sx-b";
export var arrowButtonContainer = "_sx-9";
export var arrowButtonIcon = "_sx-a";
export var carouselArrowButton = "_sx-6";
export var carouselElementContainer = "_sx-1";
export var galleryThumbnail = "_sx-d";
export var galleryThumbnailImage = "_sx-e";
export var left = "_sx-7";
export var productDisplayCarouselContainer = "_sx-0";
export var productTileContainer = "_sx-2";
export var productTileImage = "_sx-4";
export var productTileImageContainer = "_sx-3";
export var productTileTitle = "_sx-5";
export var right = "_sx-8";
export var sliderOverflow = "_sx-c";